module.exports = __webpack_public_path__ + "img/monumento.b9fd10da.jpg";